import React, {useState}  from 'react';

function BtnLike() {//좋아요 아이콘
  const [isLikeActive, setIsLikeActive] = useState(false);
  return(
   <button
   onClick={() => {
    setIsLikeActive(!isLikeActive);
   }}
   className={`btn_like ${isLikeActive ? `active` : ``}`}
 />
  )
 }
 export default BtnLike;